import { Button, Box, type BoxProps, Flex, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Badge, BoxCollapsible, Icon } from '@flecto/ui'

import { useBookingInsuranceCardStatus } from '../../hooks/useBookingInsuranceCardStatus'
import styles from './styles.module.css'

type CardBookingInsuranceProps = Omit<BoxProps, 'children'> & {
  bookingId?: ParameterID
  onClick?: () => void
}
export function CardBookingInsuranceStatus({
  bookingId,
  ...props
}: CardBookingInsuranceProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_insurances' })

  const { icon, title, badge, action, isLoading } =
    useBookingInsuranceCardStatus({
      bookingId,
    })

  return (
    <Box className={styles.cardBookingInsuranceStatus} {...props}>
      <BoxCollapsible title={t('instant_insurance')}>
        <Flex align='flex-start' justify='space-between' gap='md'>
          {icon.show && (
            <Icon
              icon={icon.icon}
              color={icon.color}
              withCircleBackground
              size='sm'
              style={{ flexShrink: 0 }}
            />
          )}
          <Box style={{ flex: 1 }}>
            {title.show && <Text c={title.color}>{title.label}</Text>}
            <Flex
              align='center'
              justify='space-between'
              mt='xs'
              style={{ flex: 1 }}
            >
              {badge.show && typeof badge.label !== 'string'
                ? badge.label
                : badge.show && (
                    <Badge color={badge.color} ml={-5} size='sm'>
                      {badge.label}
                    </Badge>
                  )}
              {action.show && (
                <Button
                  size='sm'
                  px={0}
                  mr='md'
                  variant='transparent'
                  loading={isLoading}
                  onClick={() => action.click()}
                  style={{ padding: 0, position: 'absolute', right: 0 }}
                >
                  {!isLoading ? action.label : ''}
                </Button>
              )}
            </Flex>
          </Box>
        </Flex>
      </BoxCollapsible>
    </Box>
  )
}
